import React, { useState } from 'react';
import Login from './Login';
import Register from './Register';

// Indirizzo condivisibile con chi deve creare l'account:
// social.bymarke.com/registrati apre direttamente il modulo di registrazione.
const PERCORSO_REGISTRAZIONE = '/registrati';

/**
 * Schermata mostrata a chi non ha ancora effettuato l'accesso:
 * alterna il modulo di login e quello di registrazione, tenendo
 * l'indirizzo del browser allineato a ciò che si sta vedendo.
 */
const AuthGate: React.FC = () => {
  const [mostraRegistrazione, setMostraRegistrazione] = useState(
    () => window.location.pathname.toLowerCase() === PERCORSO_REGISTRAZIONE
  );

  const vaiA = (registrazione: boolean) => {
    setMostraRegistrazione(registrazione);
    window.history.replaceState(null, '', registrazione ? PERCORSO_REGISTRAZIONE : '/');
  };

  if (mostraRegistrazione) {
    return <Register onBackToLogin={() => vaiA(false)} />;
  }

  return <Login onRegisterClick={() => vaiA(true)} />;
};

export default AuthGate;
